import { withFieldHint } from "@/src/components/HighOrderComponents";
import { RatingField } from "@/src/components/Fields/RatingField";
import { useFormContext } from "react-hook-form";
import { useAnalytics } from "@/src/components/pages/StepPage/components/useAnalytics";

const RatingFieldWithHint = withFieldHint(RatingField);

export function RatingInput(props: any) {
  const { hint, name } = props;
  const hints = hint?.hintsList;
  const form = useFormContext();
  const { trackAnalyticEvent } = useAnalytics();
  const { control } = form;
  if (!name) return null;
  return (
    <RatingFieldWithHint
      {...props}
      onChange={(value: number) => {
        trackAnalyticEvent("rating_selected", { rating: value });
        props?.onChange?.(value);
      }}
      control={control}
      name={name}
      hints={hints}
    />
  );
}
